import React from 'react';
import './tour-finale.css';

export default function EndOfTour({ moving, onReturn }) {
  return <div className={`tour-finale ${moving ? 'is-arriving' : 'is-ready'}`} data-tour-end="true">
    <span className="tour-mascot" aria-hidden="true"><img src="/brand/scorpion-symbol.svg" alt=""/><i/><i/></span>
    <span className="tour-finale-copy" role="status" aria-live="polite" aria-atomic="true">
      {!moving && <><strong>おしまい。</strong><small>また、ひとまわり？</small></>}
    </span>
    <button className="tour-return" onClick={onReturn} disabled={moving} aria-label="Return to entrance">
      <span aria-hidden="true">↻</span> 入口へ
    </button>
  </div>;
}
